import { render } from "./InstallLocsIconField.vue?vue&type=template&id=0f626da2&scoped=true"
import script from "./InstallLocsIconField.vue?vue&type=script&lang=js"
export * from "./InstallLocsIconField.vue?vue&type=script&lang=js"

import "./InstallLocsIconField.vue?vue&type=style&index=0&id=0f626da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f626da2"]])

export default __exports__